"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonService = exports.commonServiceMap = void 0;
var typedi_1 = require("typedi");
var DecoratorMetadataStorage_1 = require("./DecoratorMetadataStorage");
exports.commonServiceMap = new Map();
function CommonService(alias, options) {
    if (options && options.replaceAngularService) {
        if (!Array.isArray(options.replaceAngularService)) {
            options.replaceAngularService = [options.replaceAngularService];
        }
    }
    return function (constructor) {
        DecoratorMetadataStorage_1.getDecoratorMetadataStorage().setCommonService(alias, { alias: alias, options: options });
        exports.commonServiceMap.set(alias, constructor);
        typedi_1.Service()(constructor);
    };
}
exports.CommonService = CommonService;
//# sourceMappingURL=CommonService.decorator.js.map